import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { StyledLinksSettings } from "./index.styled";
import SettingsSectionTitle from "../SettingsSectionTitle";
import LinkIcon from "../../../assets/icons/link-blue.webp";
import InfoIcon from "../../../assets/icons/info.png";
import AddLinksIcon from "../../../assets/images/add-links.png";
import RatingLink from "../RatingLink";
import JoinLinks from "../JoinLinks";
import { getConfig, type AppConfig } from "../../../utils/config";
import type { RootState } from "../../../store";

const LinksSettings = () => {
  const { data } = useSelector((state: RootState) => state.dashboard);
  const [config, setConfig] = useState<AppConfig | null>(null);

  useEffect(() => {
    getConfig().then(setConfig);
  }, []);

  if (!config) {
    return null;
  }

  const joinTriggers = data.triggers.filter(
    (trigger) => trigger.type === "join"
  );
  const rateTriggers = data.triggers.filter(
    (trigger) => trigger.type === "rate"
  );

  const ratingLink =
    rateTriggers.length > 0
      ? {
        text: rateTriggers[0].text,
        shortLink:
          config.SHOW_SHORT_LINK &&
            rateTriggers[0].short_link_id
            ? `https://wa.me/message/${rateTriggers[0].short_link_id}`
            : undefined,
        longLink: `https://wa.me/${config.WHATSAPP_PHONE_NUMBER
          }?text=${rateTriggers[0].text.replaceAll(" ", "+")}`,
        triggerId: rateTriggers[0].ID,
      }
      : null;

  const joinLinks = joinTriggers.map((trigger) => {
    const encodedText = trigger.text.replaceAll(" ", "+");
    const longLink = `https://wa.me/${config.WHATSAPP_PHONE_NUMBER
      }?text=${encodedText}`;

    return {
      id: trigger.ID,
      text: trigger.text,
      shortLink:
        config.SHOW_SHORT_LINK && trigger.short_link_id
          ? `https://wa.me/message/${trigger.short_link_id}`
          : undefined,
      longLink: longLink,
      name: trigger.name,
      short_link_id: trigger.short_link_id,
      triggerId: trigger.ID,
    };
  });

  const handleAddLinkClick = () => {
    window.open(
      `https://wa.me/${config.WHATSAPP_ADD_LINK_PHONE
      }?text=אני+רוצה+קישור+נוסף`,
      "_blank"
    );
  };

  return (
    <StyledLinksSettings>
      <div className="links-header">
        <SettingsSectionTitle title="קישורים" icon={LinkIcon} />
        <img
          src={AddLinksIcon}
          alt="הוסף קישור"
          className="add-link-icon"
          onClick={handleAddLinkClick}
        />
      </div>
      <div className="links-settings-subtitle">
        <img src={InfoIcon} alt="info" />
        חשוב לדעת, תוקף הקישורים הוא 7 ימים בלבד
      </div>
      {ratingLink && <RatingLink link={ratingLink} />}
      <JoinLinks joinLinks={joinLinks} />
    </StyledLinksSettings>
  );
};

export default LinksSettings;
